import { Accordion } from 'react-bootstrap';

import CollectionSearch from './_CollectionSearch';
import { UserContext } from 'Vendor/Context/UserContextProvider';
import CollectionPicker from './_CollectionPicker';
import { useContext, useState } from 'react';
import Creation from 'Entity/Creation';

interface ListingProps {
    creationId: number
    creation: Creation
}

const Listing = ({ creationId, creation }: ListingProps) => {
    const { currentUser } = useContext(UserContext);
    const [searchTerm, setSearchTerm] = useState('');

    const selectedBrandIds = creation.brands?.map(brand => brand.id).filter((id): id is number => undefined !== id) ?? [];
    const hasBrandFilter = selectedBrandIds.length > 0;

    const availableCollections = [
        ...(currentUser?.currentOrganization?.buckets || [])
            .filter(bucket => !hasBrandFilter || (undefined !== bucket.brand?.id && selectedBrandIds.includes(bucket.brand.id)))
            .map(b => ({ ...b, type: 'bucket' as const })),
        ...(currentUser?.currentOrganization?.catalogs || [])
            .filter(catalog => !hasBrandFilter || (undefined !== catalog.brand?.id && selectedBrandIds.includes(catalog.brand.id)))
            .map(c => ({ ...c, type: 'catalog' as const })),
        { primarySlug: 'external', name: 'External Files', type: 'external', items: [] }
    ];
    const defaultActiveKeys = availableCollections.map(c => c.primarySlug);

    return (
        <>
            <div className="d-flex flex-column align-items-start mb-3">
                <CollectionSearch onSearch={setSearchTerm} />
            </div>

            <Accordion defaultActiveKey={defaultActiveKeys} alwaysOpen flush>
                {availableCollections.map((collection) => (
                    <CollectionPicker
                        key={`${collection.type}-${collection.primarySlug}`}
                        collection={collection}
                        type={collection.type as 'bucket' | 'catalog' | 'external'}
                        creationId={creationId}
                        searchTerm={searchTerm}
                    />
                ))}
            </Accordion>

            <hr className="border-secondary mt-4" />
        </>
    );
};

export default Listing;
